import React, { useState, useEffect } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import apiClient from "../../axiosInstance";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const VehicleInspectionList = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Vehicle Inspections List", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const fetchItems = async () => {
    try {
      const result = await apiClient.get("/inspections/vehicle-inspections");
      setData(result.data.response || result.data || []);
    } catch (err) {
      console.error("Error fetching vehicle inspections:", err);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleDeleteInspection = async (inspectionId) => {
    const confirmResult = await Swal.fire({
      title: "Delete Inspection?",
      text: "Are you sure you want to delete this vehicle inspection?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    try {
      const response = await apiClient.delete(
        `/inspections/vehicle-inspections/${inspectionId}`
      );

      if (response.data.status === "success") {
        setData((prevData) =>
          prevData.filter((item) => item.inspection_id !== inspectionId)
        );
        await Swal.fire({
          title: "Deleted",
          text: response.data.message || "Vehicle inspection deleted successfully",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      await Swal.fire({
        title: "Delete Failed",
        text: response.data.message || "Failed to delete vehicle inspection",
        icon: "error",
      });
    } catch (error) {
      console.error("Error deleting vehicle inspection:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to delete vehicle inspection";
      await Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "license_plate",
      header: "License Plate",
    },
    {
      accessorKey: "model_name",
      header: "Model",
    },
    {
      accessorKey: "branch",
      header: "Branch",
    },
    {
      accessorKey: "owner_name",
      header: "Owner",
      cell: ({ row }) => (
        <>
          {row.original.owner_name || "-"}
          {row.original.owner_phone ? (
            <span className="badge bg-secondary ms-1">
              {row.original.owner_phone}
            </span>
          ) : null}
        </>
      ),
      accessorFn: (row) =>
        `${row.owner_name || ""} ${row.owner_phone || ""}`,
      filterFn: "includesString",
      enableColumnFilter: true,
    },
    {
      accessorKey: "inspection_date",
      header: "Inspection Date",
      cell: ({ row }) =>
        row.original.inspection_date
          ? new Date(row.original.inspection_date).toLocaleDateString()
          : "",
    },
    {
      accessorKey: "inspector",
      header: "Inspector",
    },
    {
      accessorKey: "result",
      header: "Result",
      cell: ({ row }) => (
        <span
          className={`badge bg-${
            row.original.result === "Passed" ? "success" : "danger"
          }`}
        >
          {row.original.result}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex gap-1">
          <Link
            to={`/updateInspectVehicle/${row.original.inspection_id}`}
            className="btn btn-sm btn-primary"
          >
            <i className="ri-file-edit-line"></i>
          </Link>
          <Link
            to={`https://daryeelinspection.com/api/inspections/vehicle-inspections/${row.original.inspection_id}/report`}
            className="btn btn-sm btn-info ms-1"
            target="_blank"
          >
            <i className="ri-file-text-line"></i>
          </Link>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleDeleteInspection(row.original.inspection_id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              title="Vehicle Inspections List"
              breadcrumbItems={breadcrumbItems}
            />
          </div>
        </div>
        <div className="mb-3 text-end"></div>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-12 text-end mb-2">
                    <Link to="/inspectVehicle">
                      <button className="btn btn-primary">
                        Inspect Vehilce
                      </button>
                    </Link>
                  </div>
                </div>
                <TanstackTable data={data} columns={columns} />
              </CardBody>
            </Card>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default VehicleInspectionList;
